export const formatDateForView = (isoDate) => {
  if (!isoDate) return '';
    return isoDate.split('T')[0].split('-').reverse().join('.');
};